import { Stack, useTheme } from '@mui/material';
import { ReactNode } from 'react';
import { DynamicIcon } from 'src/components';

export const ChatActivityContainer = ({ icon, title }: { icon: string; title: ReactNode }) => {
  const theme = useTheme();
  return (
    <Stack
      direction="row"
      sx={{
        marginTop: '0.5rem',
      }}
    >
      <DynamicIcon
        name={icon}
        sx={{
          fontSize: '0.75rem',
          width: '0.75rem',
          height: '0.75rem',
          lineHeight: '0.75rem',
          mr: '0.5rem',
          ml: '0.75rem',
          my: '0.3rem',
          color: theme.palette.custom.tertiary.tertiary40,
        }}
      />
      <Stack direction="row" alignItems="center">
        {title}
      </Stack>
    </Stack>
  );
};
